import { ArrowDownRight, ArrowUpRight, Minus } from "@phosphor-icons/react";
import type { GlossaryTerm } from "../types";
import { HelpButton } from "./HelpButton";

type MetricBlockProps = {
  label: string;
  value: string;
  meta?: string;
  change?: number | null;
  term?: GlossaryTerm;
  onHelp: (term: GlossaryTerm) => void;
  tone?: "default" | "positive" | "warning";
};

export function MetricBlock({ label, value, meta, change, term, onHelp, tone = "default" }: MetricBlockProps) {
  const ChangeIcon = change === null || change === undefined || change === 0 ? Minus : change > 0 ? ArrowUpRight : ArrowDownRight;
  return (
    <article className={`metric-block metric-block--${tone}`}>
      <div className="metric-block__top">
        <span>{label}</span>
        <HelpButton term={term} onOpen={onHelp} />
      </div>
      <strong>{value}</strong>
      <div className="metric-block__meta">
        {change !== null && change !== undefined && (
          <span className={change > 0 ? "change-positive" : change < 0 ? "change-negative" : "change-flat"}>
            <ChangeIcon size={14} aria-hidden="true" />
            {Math.abs(change).toFixed(1)}%
          </span>
        )}
        {meta && <span>{meta}</span>}
      </div>
    </article>
  );
}

